/**
 * Client-side Supabase instance for browser use.
 * Used for OAuth flows and direct table access (waitlist).
 * These are PUBLIC values — RLS controls data access.
 */
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://exdukxfmojgecpalbntm.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4ZHVreGZtb2pnZWNwYWxibnRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ0NjkyMTcsImV4cCI6MjA5MDA0NTIxN30.UWr1hsmSCDDxOve3jJ_tQri1Uu30QXH0IyKf364msC8";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
